<template>
    <div :class="{ 'is-invalid': hasError }">
        <div
            class="radio-toggle btn-group btn-group-toggle"
            :class="{
                'flex-md-row flex-column': orientation === 'horizontal' && toggleOrientationOnSmallScreen,
                'flex-md-column flex-row': orientation === 'vertical' && toggleOrientationOnSmallScreen,
                'flex-row': orientation === 'horizontal' && !toggleOrientationOnSmallScreen,
                'flex-column': orientation === 'vertical' && !toggleOrientationOnSmallScreen,
                'is-invalid': hasError,
            }"
        >
            <label
                v-for="option in options"
                :key="option.value"
                class="btn btn-default"
                :class="{ 'active': selectedValue === option.value }"
            >
                <input
                    type="radio"
                    autocomplete="off"
                    :name="name"
                    :value="option.value"
                    :checked="selectedValue === option.value"
                    @change="onChange(option.value)"
                    @click="onClick(option.value)"
                >
                <span v-html="option.label"></span>
            </label>
        </div>
        <small class="invalid-feedback d-block" v-show="hasError">
            {{ errorMsg }}
        </small>
    </div>
</template>

<script>
import {ref} from "vue";

export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        modelValue: {
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        sameSelectionUnsetsValue: {
            type: Boolean,
            required: false,
            default: false,
        },
        orientation: {
            type: String,
            required: false,
            default: 'horizontal',
        },
        toggleOrientationOnSmallScreen: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorMsg: {
            type: String,
            required: false,
            default: '',
        }
    },
    setup(props) {
        return {
            selectedValue: ref(props.modelValue),
        }
    },
    methods: {
        onChange(selectedValue) {
            this.selectedValue = selectedValue

            this.$emit('update:modelValue', selectedValue)
        },
        onClick(selectedValue) {
            if (this.selectedValue === selectedValue && this.sameSelectionUnsetsValue) {
                this.onChange(null)
            }
        }
    },
    emits: [
        'update:model-value',
        'update:modelValue',
    ],
}
</script>

<style scoped>
.radio-toggle .btn {
    border-color: white;
}

.radio-toggle .btn.active {
    border-color: white !important;
    background-color: #3e8ef7 !important;
    color: white !important;
}
</style>
